import { createSlice } from "@reduxjs/toolkit";
import { getReviewStaticThunk } from "./thunk";

export const initialState: any = {
  reviews: [],
  counts: 0,
  reviewStatics:{},
};

const ReviewSlice = createSlice({
  name: 'ReviewSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
  
    builder
      .addCase(getReviewStaticThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReviewStaticThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.reviewStatics = action.payload;
      })
      .addCase(getReviewStaticThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

  },

}
);

export default ReviewSlice.reducer;